import {
  DELETE_CURRENT_DOC,
  HOME,
  LOGIN_SUCCESS,
  SET_CURRENT_DOC,
  SHIABUD_FORM,
  SHIABUD_SUBMITTED,
  TEMP_LIC,
  TEMP_LIC_REQ,
  UPLOAD_DOC,
  UPLOAD_SIGNED_DOC,
  SIGNATURE_ERROR,
  SET_NOTIF,
  UPLOAD_DOC_ERROR
} from "../actions/types";

const initialState = {
  data: null,
  orders: [],
  shiabud_form: null,
  temp_lic: null,
  current_doc: null,
  signature_sent: [],
  signature_error: false,
  files_sent: [],
  files_error: false
};

const dataReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case HOME:
      return {
        ...state,
        data: payload.data,
        orders: payload.orders,
      };
    case SET_NOTIF:
      return {
        ...state,
      };
    case SHIABUD_FORM:
      return {
        ...state,
        shiabud_form: payload,
      };
    case SHIABUD_SUBMITTED:
      return {
        ...state,
      };
    case TEMP_LIC:
      return {
        ...state,
        temp_lic: payload,
      };
    case TEMP_LIC_REQ:
      return {
        ...state,
      };
    case UPLOAD_DOC:
      
      return { ...state,
              files_error: false,
              files_sent: [payload] 
             };
    case UPLOAD_DOC_ERROR:
      // if payload is false it means we init the state of doc upload - so we init files_sent as well
      return {
        ...state,
        files_error: payload,
        files_sent: payload ? state.files_sent : []
      };  
    case LOGIN_SUCCESS:
      return {
        ...state,
        orders: payload.orders,
      };
    case SET_CURRENT_DOC:
      return {
        ...state,
        current_doc: payload,
      };
    case DELETE_CURRENT_DOC:
      return {
        ...state,
        current_doc: null,
      };
    case UPLOAD_SIGNED_DOC:
      return {
        ...state,
        signature_error: false,
        signature_sent: [...state.signature_sent, payload]
      };
    case SIGNATURE_ERROR:
        return {
          ...state,
          signature_error: payload
        };  
    default:
      return state;
  }
};

export default dataReducer;
